<template>
  <Grid
    gtc="1fr 1fr"
    gta="'total-overview forecast-card' 'table table'"
    gap="var(--r-space-md) var(--r-space-sp)"
    class="price-forecast full-height"
  >
    <ForecastCard ref="forecastCard" class="sticky-card" @apply-on-selection="applyOnSelection" />
    <TotalOverview class="sticky-card" />
    <ForecastTable ref="forecastTable" :key="rerenderTable" @rerender-table="rerenderTable++" />
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import PriceForecastModule from './price-forecast-module'
// Libraries
import { mapState, mapMutations, mapActions } from 'vuex'
// Components
import ForecastCard from './components/ForecastCard'
import TotalOverview from './components/total-overview/TotalOverview'
import ForecastTable from './components/forecast-table/ForecastTable'

export default {
  name: 'PriceForecast',

  components: {
    ForecastCard,
    TotalOverview,
    ForecastTable
  },

  data: () => ({
    rerenderTable: 1
  }),

  computed: {
    ...mapState('predictions', ['financialPeriodId'])
  },

  beforeCreate() {
    this.$store.registerModule('price-forecast', PriceForecastModule)
  },

  beforeDestroy() {
    this.$store.unregisterModule('price-forecast')
  },

  methods: {
    ...mapMutations('price-forecast', ['setRowsSelected', 'setSelectAll']),
    ...mapActions('price-forecast', ['getAndSetOverviewData']),

    applyOnSelection(payload) {
      const { gridApi } = this.$refs.forecastTable.$refs.agGrid.getAgGrid()

      this.$refs.forecastCard.setLoadingBtnState(true)
      apiTo
        .CHANGE_FORECASTED_PRICE_FOR_SUBSCRIPTION_PERIODS({
          ...payload,
          filterModel: gridApi.getFilterModel(),
          filter_financial_period_id: this.financialPeriodId
        })
        .then(() => {
          this.$refs.forecastCard.resetData()
          this.setRowsSelected([])
          this.setSelectAll(false)
          this.$refs.forecastTable.purgeServerSideCache()
          this.getAndSetOverviewData()
        })
        .finally(() => this.$refs.forecastCard.setLoadingBtnState(false))
    }
  }
}
</script>

<style lang="scss" scoped>
.sticky-card {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
